import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import Axios from "../Axios";
import { Urls } from "../Urls";
import { initializeData } from "../Components/Wizard/utility";
import { ContextConstants, useAppContext } from "../Context/AppContext";
import { Activity, currentRequestTimeStamp } from "../Constants";

const normalizePhone = (phone = "") => {
  return phone.toString().replace(/\s/g, "");
};

const getLoggedInUserName = (data, loggedInPhone) => {
  const phone = normalizePhone(loggedInPhone);
  const contacts = data?.contact_information || [];

  const match = contacts.find((contact) => {
    const contactPhone = normalizePhone(contact?.contact_number);

    return (
      contactPhone === phone ||
      contactPhone.endsWith(phone) ||
      phone.endsWith(contactPhone)
    );
  });

  return match?.name || "";
};

export const useTransporterData = () => {
  const { dispatch, clientIp } = useAppContext();

  const countryCode = localStorage.getItem("countryCode");

  const query = useQuery({
    queryKey: ["initTransporter", countryCode],

    queryFn: async () => {
      const url = countryCode
        ? `${Urls.Transporter.Get}?cc=${countryCode}`
        : Urls.Transporter.Get;

      const response = await Axios.get(url);
      const freshData = response.data;
      const shouldLogSignIn = localStorage.getItem("loggedin") === "yes";

      if (
        shouldLogSignIn &&
        freshData?.transporter_id &&
        freshData?.transporter_name
      ) {
        const loggedInPhone = freshData?.user_details?.contact_number || "";
        const loggedInUserName = getLoggedInUserName(freshData, loggedInPhone);
        localStorage.setItem("loggedin", "no");
        localStorage.setItem("userName", loggedInUserName);

        Activity(
          [
            {
              screen: "sign in",
              module: "login",
              user_activity: "Logged in successfully",
              timestamp: currentRequestTimeStamp(),
            },
          ],
          "Sign-In",
          freshData.transporter_name,
          freshData.transporter_id,
          clientIp || sessionStorage.getItem("ClientIP") || "",
          loggedInPhone
        );
      }

      return freshData;
    },

    refetchOnWindowFocus: false,
    refetchOnMount: "always",
    retry: 1,
    staleTime: 0,
    cacheTime: 0,
  });

  const { data } = query;

  useEffect(() => {
    if (!data) return;

    try {
      const {
        procurement,
        locations,
        network,
        expressed_interest,
        streaming_data_input,
        user_procurement_data,
        ...cleanedTransporterData
      } = data;

      const initializedData = initializeData(cleanedTransporterData);

      dispatch({
        type: ContextConstants.SetData,
        payload: initializedData,
      });

      const loggedInPhone = data?.user_details?.contact_number || "";

      if (loggedInPhone) {
        dispatch({
          type: ContextConstants.SetLoggedInPhone,
          payload: loggedInPhone,
        });
      }
    } catch (err) {
      console.error("useTransporterData error:", err);
    }
  }, [data, dispatch]);

  return query;
};